module.exports = __webpack_public_path__ + "resources/img/img_tibero5_en.755fc1719ffbcefb62d04e23322d3260.png";